<div class="row">
  <div
    class="col-lg-6 col-md-6 col-sm-6 col-xs-10 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-xs-offset-1"
  >
    <form
      (ngSubmit)="onSubmit()"
      [formGroup]="loginForm"
      autocomplete="off"
      class="wb-login__form"
    >
      <div class="wb-login__form-sign wb-login__form-sign-login"></div>
      <div class="wb-login__form-title">
        {{ l10n('ls_start_screen_login_form_title') }}
      </div>
      <div
        *ngIf="
          invalidCredentials &&
          invalidCredentialsWarningLocalizationKey &&
          !warningLocalizationKey
        "
        class="warning-alert"
      >
        <div class="warning-alert__sign"></div>
        <div class="warning-alert__message">
          {{ l10n(invalidCredentialsWarningLocalizationKey) }}
        </div>
      </div>
      <div
        *ngIf="
          warningLocalizationKey && !invalidCredentialsWarningLocalizationKey
        "
        class="warning-alert"
      >
        <div class="warning-alert__sign"></div>
        <div class="warning-alert__message">
          {{ l10n(warningLocalizationKey) }}
        </div>
      </div>
      <div *ngIf="isServerError" class="warning-alert">
        <div class="warning-alert__sign"></div>
        <div class="warning-alert__message">
          {{ l10n(serverErrorWarningLocalizationKey) }}
        </div>
      </div>
      <div *ngIf="isInitialPasswordExpired" class="warning-alert">
        <div class="warning-alert__sign"></div>
        <div class="warning-alert__message">
          {{ l10n(initialPasswordExpiredWarningLocalizationKey) }}
        </div>
      </div>
      <div class="form-group">
        <label for="username" class="wb-login__label">{{
          l10n('ls_start_screen_login_field_label')
        }}</label>
        <div class="wb-login__input-container">
          <div
            *ngIf="
              usernameFormat.inputPrefix &&
              usernameFormat.isInputPrefixUnremovable &&
              usernameFormat.inputPaddingLeft
            "
            class="wb-login__prefix-container"
          >
            <span class="wb-login__prefix">{{
              usernameFormat.inputPrefix
            }}</span>
          </div>
          <input
            id="username"
            #usernameInput
            type="text"
            formControlName="username"
            autocomplete="off"
            tabindex="1"
            placeholder="{{ l10n('usernamePlaceholder') }}"
            [textMask]="
              usernameFormat.inputPattern
                ? { mask: usernameFormat.inputPattern, guide: false }
                : { mask: false }
            "
            [ngStyle]="
              usernameFormat.inputPrefix &&
              usernameFormat.isInputPrefixUnremovable &&
              usernameFormat.inputPaddingLeft
                ? { 'padding-left': usernameFormat.inputPaddingLeft }
                : ''
            "
            [class.wb-login__input_invalid]="
              invalidUsername || invalidCredentials
            "
            (focus)="
              isPasswordOnScreenKeyboard
                ? switchUsernameOnscreenKeyboard()
                : null
            "
            class="form-control wb-login__input"
          />
        </div>
        <div
          [class.active]="isUsernameOnScreenKeyboard"
          (click)="switchUsernameOnscreenKeyboard()"
          class="wb-login__keyboard-icon"
        ></div>
      </div>
      <div class="form-group">
        <a
          (click)="showForgotPasswordModal()"
          class="wb-login__forgot-password text text_body text_linked"
          >{{ l10n('ls_start_screen_forgot_password_link') }}</a
        >
        <label for="password" class="wb-login__label">{{
          l10n('ls_start_screen_password_field_label')
        }}</label>
        <input
          id="password"
          #passwordInput
          type="password"
          formControlName="password"
          autocomplete="off"
          tabindex="2"
          placeholder="{{ l10n('ls_start_screen_password_field_placeholder') }}"
          [class.wb-login__input_invalid]="
            invalidPassword || invalidCredentials
          "
          (focus)="
            isUsernameOnScreenKeyboard ? switchPasswordOnscreenKeyboard() : null
          "
          class="form-control wb-login__input"
        />
        <div
          [class.active]="isPasswordOnScreenKeyboard"
          (click)="switchPasswordOnscreenKeyboard()"
          class="wb-login__keyboard-icon"
        ></div>
        <onscreen-keyboard
          *ngIf="isUsernameOnScreenKeyboard"
          [form]="loginForm"
          [inputName]="'username'"
          (onReturnPress)="hasAllRequiredFields ? onSubmit() : null"
        ></onscreen-keyboard>
        <onscreen-keyboard
          *ngIf="isPasswordOnScreenKeyboard"
          [form]="loginForm"
          [inputName]="'password'"
          (onReturnPress)="hasAllRequiredFields ? onSubmit() : null"
        ></onscreen-keyboard>
      </div>
      <auth-button
        id="auth-button"
        [isDisabled]="isLogging || !hasAllRequiredFields"
        [caption]="
          !isLogging
            ? l10n('ls_start_screen_login_button_normal')
            : l10n('authorization')
        "
        [showLoader]="isLogging"
        [buttonType]="'submit'"
      ></auth-button>
    </form>
  </div>
</div>
